import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
    const [seconds, setSeconds] = useState(5);
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    navigate("/");
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [navigate]);

    return (
        <div style={s.page}>
            <div style={s.box}>
                <div style={s.code}>404</div>
                <h1 style={s.title}>Page not found</h1>
                <p style={s.sub}>This card or page doesn't exist.</p>
                <div style={s.timerWrap}>
                    <div style={s.timerRing}>
                        <span style={s.timerNum}>{seconds}</span>
                    </div>
                    <p style={s.timerText}>Redirecting to home...</p>
                </div>
                <button onClick={() => navigate("/")} style={s.btn}>
                    Go Home Now →
                </button>
            </div>
        </div>
    );
}

const s = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f0c29 0%, #1a1a2e 50%, #0f3460 100%)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "1rem", fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    box: {
        background: "#fff", borderRadius: "24px",
        padding: "3rem 2.5rem", width: "100%", maxWidth: "400px",
        textAlign: "center", boxShadow: "0 40px 80px rgba(0,0,0,0.5)",
    },
    code: {
        fontSize: "5rem", fontWeight: "900",
        background: "linear-gradient(135deg, #6366f1, #4f46e5)",
        WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
        lineHeight: 1, marginBottom: "0.5rem",
    },
    title: { fontSize: "1.5rem", fontWeight: "800", color: "#1a1a2e", margin: "0 0 0.5rem" },
    sub: { fontSize: "0.9rem", color: "#6b7280", margin: "0 0 2rem" },
    timerWrap: { display: "flex", flexDirection: "column", alignItems: "center", gap: "0.6rem", marginBottom: "1.5rem" },
    timerRing: {
        width: "64px", height: "64px", borderRadius: "50%",
        border: "4px solid #6366f1",
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "#f0f0ff",
    },
    timerNum: { fontSize: "1.5rem", fontWeight: "900", color: "#6366f1" },
    timerText: { fontSize: "0.82rem", color: "#9ca3af", margin: 0 },
    btn: {
        padding: "0.85rem 2rem",
        background: "linear-gradient(135deg, #6366f1, #4f46e5)",
        color: "#fff", border: "none", borderRadius: "12px",
        fontSize: "0.95rem", fontWeight: "700", cursor: "pointer",
        boxShadow: "0 4px 16px rgba(99,102,241,0.3)",
    },
};
